import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce668bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tool bg-white relative overflow-y-scroll" }
const _hoisted_2 = {
  key: 0,
  class: "body"
}
const _hoisted_3 = { class: "buttons-section sticky top-0 bg-white z-20" }
const _hoisted_4 = { class: "button-row pt-6 pb-8" }
const _hoisted_5 = { class: "title-section sticky top-0 bg-white z-20" }
const _hoisted_6 = { class: "title-row" }
const _hoisted_7 = { class: "font-bold block text-left pb-4" }
const _hoisted_8 = { class: "searchbar flex" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "tool-items w-full"
}
const _hoisted_11 = { class: "titles grid grid-cols-5" }
const _hoisted_12 = { class: "first text-left" }
const _hoisted_13 = { class: "second text-left" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "third text-left col-span-2" }, "Aggiunto il", -1))
const _hoisted_15 = { class: "tool-items-list list overflow-y-hidden" }
const _hoisted_16 = { class: "tool-item flex text-left overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_ToolItemCard = _resolveComponent("ToolItemCard")!
  const _component_AddNewToolItemModalDialog = _resolveComponent("AddNewToolItemModalDialog")!
  const _component_DeleteTool = _resolveComponent("DeleteTool")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.tool)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_SecondaryButton, {
                  class: "archive-tool text-white bg-primary-900 block float-right",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingAddNewToolItemDialog = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Aggiungi")
                  ]),
                  _: 1
                }),
                (!_ctx.isProtectedTool)
                  ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                      key: 0,
                      class: "archive-tool text-white delete-button block float-right mr-3",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingDeleteToolDialog = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Elimina")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.tool.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "text px-4 py-3 flex-grow bg-gray-100 text-black",
                type: "text",
                placeholder: `Cerca ${_ctx.tool.name.toLowerCase()}`,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
              }, null, 40, _hoisted_9), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _createVNode(_component_PrimaryButton, {
                class: "button bg-gray-100 text-black flex-none",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cerca")
                ]),
                _: 1
              })
            ]),
            (_ctx.toolItems.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.tool.primaryFieldName), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.tool.secondaryFieldName), 1),
                    _hoisted_14
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolItems, (toolItem) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_ToolItemCard, {
                          "model-value": toolItem,
                          onUpdate: _ctx.onToolItemAssignmentUpdate
                        }, null, 8, ["model-value", "onUpdate"])
                      ]))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowingAddNewToolItemDialog)
        ? (_openBlock(), _createBlock(_component_AddNewToolItemModalDialog, {
            key: 1,
            "model-value": _ctx.tool,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowingAddNewToolItemDialog = false))
          }, null, 8, ["model-value"]))
        : _createCommentVNode("", true),
      (_ctx.isShowingDeleteToolDialog)
        ? (_openBlock(), _createBlock(_component_DeleteTool, {
            key: 2,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowingDeleteToolDialog = false)),
            toolId: _ctx.id
          }, null, 8, ["toolId"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Creazione..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}